import { styled } from '@mui/material';

const prefix = 'HusaFormSectionTabs';
const sectionTabsClasses = {
  tabs: `${prefix}-tabs`,
  tabIndicator: `${prefix}-tabIndicator`,
  tabLabel: `${prefix}-tabLabel`,
  divider: `${prefix}-divider`,
  labelContainer: `${prefix}-label`
};

const SectionTabsStyled = styled('div')(({ theme }) => ({
  [`& .${sectionTabsClasses.tabs}`]: {
    marginBottom: '16px'
  },
  [`& .${sectionTabsClasses.tabIndicator}`]: {
    display: 'none'
  },
  [`& .${sectionTabsClasses.tabLabel}`]: {
    textTransform: 'none',
    fontSize: '18px',
    '& svg': {
      marginBottom: 0
    },
    paddingTop: 0,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    boxShadow: '2px -10px 3px -2px rgba(182, 182, 182, 0.75)',
    '& .MuiBox-root > svg': {
      display: 'none'
    },
    '&.Mui-selected': {
      zIndex: 1,
      background: theme.palette.primary.main,
      borderTop: '5px solid #fff',
      transition: '.2s',
      margin: '0 0 7px 0',
      transform: 'scale(1.1)',
      color: '#fff',
      boxShadow:
        '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',

      '& svg': {
        color: '#fff',
        marginBottom: 0
      },
      '& .MuiBox-root > svg': {
        display: 'block',
        color: '#fff',
        position: 'absolute',
        bottom: 0
      }
    }
  },
  [`& .${sectionTabsClasses.labelContainer}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  [`& .${sectionTabsClasses.divider}`]: {
    width: '100%',
    marginTop: -25,
    height: 1
  }
}));

export { SectionTabsStyled, sectionTabsClasses };
